import { createColumn, defaultColumns, inputTextField, booleanComponent, relationField } from '../_defaults/columns'

export const columns = [
  // createColumn({
  //   label: 'User Login Credentials',
  //   section: 'Credentials',
  //   field: 'aspnetuser',
  //   // description: 'List of allowed IP addresses from which the employee can clock in or out. Type the IP address above then hit [ENTER]',
  //   filterable: false,
  //   sortable: false,
  //   relation: {
  //     type: 'one',
  //     label: 'email',
  //     namespace: 'self',
  //     localKey: 'id',
  //     filterIs: 'text-filter'
  //     // fk: 'id'
  //   },
  //   component: {
  //     is: 'credentials-modal'
  //   }
  // }),
  createColumn({
    label: 'Username',
    isTitle: true,
    // isSubtitle: true,
    field: 'userName',
    component: inputTextField({ req: true })
  }),
  createColumn({
    label: 'Normalized Username',
    isSubtitle: true,
    field: 'normalizedUserName',
    visible: false,
    searchable: false,
    filterable: false,
    sortable: false,
    component: null
  }),
  createColumn({
    label: 'Email',
    field: 'email',
    // icon: 'email',
    // type: 'email',
    isTitle: true,
    component: inputTextField({ req: true, type: 'email' })
  }),
  createColumn({
    label: 'Normalized Email',
    field: 'normalizedEmail',
    icon: 'email',
    type: 'email',
    visible: false,
    searchable: false,
    filterable: false,
    sortable: false,
    component: null
  }),
  createColumn({
    label: 'Email Confirmed',
    field: 'emailConfirmed',
    type: 'boolean',
    visible: false,
    searchable: false,
    filterable: false,
    sortable: false,
    component: null
  }),
  createColumn({
    label: 'Phone Number',
    isSubtitle: true,
    field: 'phoneNumber',
    visible: false,
    searchable: false,
    filterable: false,
    sortable: false,
    component: null
  }),
  createColumn({
    label: 'Phone Number Confirmed',
    field: 'phoneNumberConfirmed',
    type: 'boolean',
    visible: false,
    searchable: false,
    filterable: false,
    sortable: false,
    component: null
  }),
  // createColumn({
  //   label: 'Role',
  //   field: 'role',
  //   section: 'Data Relations',
  //   // description: 'Listing of all users who have access to modify this school'
  //   ...relationField({
  //     props: {
  //       config: {
  //         params: {}
  //       }
  //     },
  //     validation: {
  //       required: true
  //     },
  //     type: 'one',
  //     localKey: 'roleId',
  //     fk: 'id',
  //     namespace: 'userRoles',
  //     filterIs: 'text-filter',
  //     label: 'id'
  //   })
  // }),
  createColumn({
    label: 'Role',
    field: 'role',
    // display: 'role.name',
    // section: 'Data Relations',
    ...relationField({
      type: 'one',
      fk: 'aspnetroles',
      localKey: 'id',
      namespace: 'aspnetroles',
      filterIs: 'text-filter',
      label: 'name',
      subtitle: ''
    })
  }),
  createColumn({
    label: 'Two Factor Enabled',
    field: 'twoFactorEnabled',
    type: 'boolean',
    visible: false,
    searchable: false,
    filterable: false,
    sortable: false,
    component: null
  }),
  createColumn({
    label: 'I Accept Terms',
    field: 'iAcceptTerms',
    type: 'number',
    visible: false,
    searchable: false,
    filterable: false,
    sortable: false,
    component: null
  }),
  createColumn({
    label: 'Locked Out',
    field: 'lockoutEnabled',
    type: 'boolean',
    // visible: false,
    component: booleanComponent
  }),
  createColumn({
    label: 'Lockout Till',
    field: 'lockoutEnd',
    type: 'date',
    defaultValue: null,
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime',
        format24h: false,
        format: 'MMM DD YYYY h:mm a'
      },
      validation: {
        required: false
      }
    }
  }),
  createColumn({
    label: 'Last Logged In',
    field: 'lastLoginDate',
    type: 'date',
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime',
        format24h: false,
        format: 'MMM DD YYYY h:mm a'
      },
      validation: {
        required: false
      }
    }
  }),
  createColumn({
    label: 'Concurrency Stamp',
    field: 'concurrencyStamp',
    type: 'textarea',
    visible: false,
    searchable: false,
    filterable: false,
    sortable: false,
    component: null
  }),
  createColumn({
    label: 'Password Hash',
    field: 'passwordHash',
    type: 'textarea',
    visible: false,
    searchable: false,
    filterable: false,
    sortable: false,
    component: null
  }),
  createColumn({
    label: 'Security Stamp',
    field: 'securityStamp',
    type: 'textarea',
    visible: false,
    searchable: false,
    filterable: false,
    sortable: false,
    component: null
  }),
  createColumn({
    label: 'Failed Logins',
    field: 'accessFailedCount',
    type: 'number',
    component: inputTextField({ req: false, type: 'number' })
  })
].concat(defaultColumns)
